window.locale = $('html').attr('lang');

$(function () {
    window.initAllOnObject($('body'));

    const menuToggle = $('.services_list .menu-toggle');
    const navPanel = $('.services_list .nav-panel');
    const submenuToggles = $('.services_list .submenu-toggle');

    menuToggle.on('click', function () {
        const isOpen = $(this).attr('aria-expanded') === 'true';

        $(this)
            .toggleClass('is-open', !isOpen)
            .attr('aria-expanded', String(!isOpen));

        navPanel.toggleClass('is-open', !isOpen);
    });

    submenuToggles.on('click', function () {
        if (window.innerWidth > 991) {
            return;
        }

        const parentItem = $(this).closest('.has-dropdown');
        const isOpen = $(this).attr('aria-expanded') === 'true';

        submenuToggles.not(this)
            .attr('aria-expanded', 'false')
            .closest('.has-dropdown')
            .removeClass('is-open');

        $(this).attr('aria-expanded', String(!isOpen));
        parentItem.toggleClass('is-open', !isOpen);
    });

    $(window).on('resize', function () {
        if (window.innerWidth > 991) {
            menuToggle.removeClass('is-open').attr('aria-expanded', 'false');
            navPanel.removeClass('is-open');
            submenuToggles.attr('aria-expanded', 'false');
            submenuToggles.closest('.has-dropdown').removeClass('is-open');
        }
    });

    $('.custom-file-input').on('change', function () {
        let files = $(this)[0].files;
        let output = [];
        for (let i = 0; i < files.length; i++) {
            output.push(files[i].name);
        }

        if (output.length < 1) {
            $(this).parent().find('label').text(translations.Choose_files);
        } else {
            $(this).parent().find('label').text(output.join());
        }
    });

    setTimeout(function () {
        $('.alert alert-danger').remove();
    }, 5000)
});

window.initSelect2 = function (items = false) {
    if (items === false) {
        items = $('.select2');
    }

    items.each(function (index, element) {
        let settings = {
            'width': '100%',
        };
        if ($(this).parents('.modal').length > 0) {
            settings['dropdownParent'] = $(this).parents('.modal').eq(0);
        }

        $(element).select2(settings);
    });
}
window.initSelect2Tags = function (items = false) {
    if (items === false) {
        items = $('.select2_tags');
    }

    items.each(function (index, element) {
        let settings = {
            'tags': true,
            'width': '100%',
        };
        if ($(this).parents('.modal').length > 0) {
            settings['dropdownParent'] = $(this).parents('.modal').eq(0);
        }

        $(element).select2(settings);
    });
}
window.initSelect2Ajax = function (items = false) {
    if (items === false) {
        items = $('.select2_ajax');
    }

    items.each(function (index, element) {
        let settings = {
            'ajax': {
                'url': $(element).data('url'),
                'data': function (params) {
                    let query = {};
                    if ($(element).data('additional') != undefined) {
                        query = JSON.parse($(element).data('additional'));
                    }

                    query['term'] = params.term;
                    query['page'] = params.page || 1;

                    return query;
                }
            },
            'width': '100%',
        };
        if ($(element).data('select2-delay')) {
            settings['ajax']['delay'] = $(element).data('select2-delay');
        }
        if ($(this).parents('.modal').length > 0) {
            settings['dropdownParent'] = $(this).parents('.modal').eq(0);
        }

        $(element).select2(settings);
    });
}
window.initSelect2AjaxTags = function (items = false) {
    if (items === false) {
        items = $('.select2_ajax_tags');
    }

    items.each(function (index, element) {
        let settings = {
            'tags': true,
            'ajax': {
                'url': $(element).data('url'),
                'data': function (params) {
                    let query = {};
                    if ($(element).data('additional') != undefined) {
                        query = JSON.parse($(element).data('additional'));
                    }

                    query['term'] = params.term;
                    query['page'] = params.page || 1;

                    return query;
                }
            },
            'width': '100%'
        };
        if ($(element).data('select2-template-result')) {
            settings['templateResult'] = window[$(element).data('select2-template-result')];
        }
        if ($(element).data('select2-template-selection')) {
            settings['templateSelection'] = window[$(element).data('select2-template-selection')];
        }
        if ($(element).data('select2-delay')) {
            settings['ajax']['delay'] = $(element).data('select2-delay');
        }
        if ($(this).parents('.modal').length > 0) {
            settings['dropdownParent'] = $(this).parents('.modal').eq(0);
        }

        $(element).select2(settings);
    });
}
window.addressFormatSelectionState = function (item) {
    return $(`<div class="address-result" data-city="${item.city || ''}" data-zipcode="${item.zip_code || ''}")>${item.address || item.text}</div>`);
}
window.initDatePicker = function (items = false) {
    if (items === false) {
        items = $('.datepicker');
    }

    let complete_locale = window.daterangepicker_locales[window.locale];
    complete_locale['format'] = 'YYYY-MM-DD';

    items.daterangepicker({
        'singleDatePicker': true,
        'autoApply': true,
        'locale': complete_locale,
    });

    items.attr('autocomplete', 'off');
}
window.initDatePickerFromToday = function (items = false) {
    if (items === false) {
        items = $('.datepicker_from_today');
    }

    let complete_locale = window.daterangepicker_locales[window.locale];
    complete_locale['format'] = 'YYYY-MM-DD';

    items.daterangepicker({
        'singleDatePicker': true,
        'autoApply': true,
        'locale': complete_locale,
        'minDate': new Date()
    });

    items.attr('autocomplete', 'off');
}
window.initDateTimePicker = function (items = false) {
    if (items === false) {
        items = $('.datetimepicker');
    }

    let complete_locale = window.daterangepicker_locales[window.locale];
    complete_locale['format'] = 'YYYY-MM-DD HH:mm';

    items.daterangepicker({
        'singleDatePicker': true,
        'autoApply': true,
        'locale': complete_locale,
        'timePicker': true,
        'timePicker24Hour': true,
    });

    items.attr('autocomplete', 'off');
}

window.initTimePicker = function (items = false) {
    if (items === false) {
        items = $('.timepicker');
    }

    items.timepicker({
        timeFormat: 'HH:mm',
        interval: 15,
        defaultTime: '00',
        dynamic: false,
        dropdown: true,
        scrollbar: true
    });

    items.attr('autocomplete', 'off');
}

window.initAutonumeric = function (items = false) {
    if (items === false)
        items = $('.autonumeric');

    items.each(function (index, element) {
        new Autonumeric(element, {
            'decimalCharacter': $(element).attr('data-decimal-character') ? $(element).attr('data-decimal-character') : '.',
            'digitGroupSeparator': $(element).attr('data-thousands-separator') ? $(element).attr('data-thousands-separator') : ' ',
            'decimalPlaces': $(element).attr('data-decimal-places') ? $(element).attr('data-decimal-places') : 2,
        })
    });

    items.attr('autocomplete', 'off');
}

window.initAllOnObject = function (object) {
    object = $(object);

    window.initSelect2(object.find('.select2'));
    window.initSelect2Tags(object.find('.select2_tags'));
    window.initSelect2Ajax(object.find('.select2_ajax'));
    window.initSelect2AjaxTags(object.find('.select2_ajax_tags'));
    window.initDatePicker(object.find('.datepicker'));
    window.initDatePickerFromToday(object.find('.datepicker_from_today'));
    window.initDateTimePicker(object.find('.datetimepicker'));
    window.initTimePicker(object.find('.timepicker'));
    window.initAutonumeric(object.find('.autonumeric'));
}

window.toggleVisibilityByCheckbox = function (source, target) {
    const input = $(target)
    if ($(source).is(':checked')) {
        input.removeClass('d-none')
    } else {
        input.addClass('d-none')
    }
}


window.showWarning = function (source, target) {
    if ($(source).is(':checked')) {
        $(target).show();
    } else {
        $(target).hide();
    }
}

   
window.getCookieNotice = function(name)  {
    const value = " " + document.cookie;    
    const parts = value.split(" " + name + "=");
    return parts.length < 2 ? undefined : parts.pop().split(";").shift();
}

window.setCookieNotice = function (name, value, expiryDays, domain, path, secure) {
  const exdate = new Date();
  exdate.setHours(
    exdate.getHours() +
      (typeof expiryDays !== "number" ? 365 : expiryDays) * 24
  );
  document.cookie =
    name +
    "=" +
    value +
    ";expires=" +
    exdate.toUTCString() +
    ";path=" +
    (path || "/") +
    (domain ? ";domain=" + domain : "") +
    (secure ? ";secure" : "");
};

$(function() {
    let cookiesBanner = $(".cookies-eu-banner");
    let cookiesBannerButton = $("button");

    cookiesBannerButton.on("click", function() {
        cookiesBanner.remove();
    });
});

let cookiesBanner = $(".cookies-eu-banner");
let cookiesBannerButton = $("button");
let cookieName = "cookies_policy";
let hasCookie = window.getCookieNotice(cookieName);

if (!hasCookie) {
    cookiesBanner.removeClass('hidden');
}

cookiesBannerButton.on("click", function() {
    window.setCookieNotice(cookieName, "closed");
    cookiesBanner.remove();
});
 
